// src/app/shared/split-storage.directive.ts
import { Directive, Input, Host, OnInit, AfterViewInit, ContentChildren, QueryList } from '@angular/core';

import { SplitComponent, SplitAreaComponent, SplitGutterInteractionEvent } from 'angular-split';

@Directive({
  selector: '[appSplitStorage]',
  standalone: false,
})
export class SplitStorageDirective implements OnInit, AfterViewInit {
  /** unique key under which sizes are saved in localStorage */
  @Input('appSplitStorage') storageKey!: string;
  @ContentChildren(SplitAreaComponent) areas!: QueryList<SplitAreaComponent>;

  constructor(@Host() private split: SplitComponent) {}

  ngOnInit() {
    if (!this.storageKey) {
      console.warn('SplitStorageDirective: No storage key provided.');
      return;
    }
    this.split.dragEnd.subscribe((e: SplitGutterInteractionEvent) => {
      localStorage.setItem(this.storageKey, JSON.stringify(e.sizes));
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      console.log('SplitStorageDirective: restoring sizes for', this.storageKey);
      if (!this.storageKey) {
        return;
      }
      const json = localStorage.getItem(this.storageKey);
      console.log('SplitStorageDirective: got stored sizes', json);
      if (!json) {
        return;
      }

      let sizes: number[];
      try {
        sizes = JSON.parse(json);
      } catch {
        console.warn('SplitStorageDirective: corrupted size data');
        return;
      }

      // only restore if the saved array matches the number of panes
      if (!Array.isArray(sizes) || sizes.length !== this.areas.length) {
        console.warn(`SplitStorageDirective: stored sizes (${sizes.length}) ` + `≠ pane count (${this.areas.length})`);
        return;
      }

      // apply each saved size via the internal API
      this.split._areas().forEach((area, i) => {
        const areaAny = area as any;
        if (typeof areaAny._internalSize === 'function') {
          // new API uses a private _internalSize() to drive the size signal
          areaAny._internalSize.set(sizes[i]);
        } else if (area.size && typeof (area.size as any).set === 'function') {
          // fallback in case area.size is a WritableSignal
          (area.size as any).set(sizes[i]);
        }
        this.split._areas().forEach(area => {
          area._internalSize.reset = () => {};
        });
      });
    }, 20);

    // no need to touch change detection—the SplitComponent’s grid-template effect
    // will automatically pick up the new signals and repaint the layout
  }
}
